import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { ButtonTheme } from '@rd/types';

type ButtonMode = 'internalURL' | 'externalURL' | 'callback';
export type ButtonType = 'reset' | 'button' | 'submit';

@Component({
  selector: 'rd-shared-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ButtonComponent implements OnInit {
  @HostBinding('class') fullButtonClass: string;
  @HostBinding('class.rd-shared-button') componentClass = true;
  @HostBinding('class.is-disabled') get isButtonDisabled(): boolean {
    return this.isDisabled;
  }

  @Input() buttonClass: string;
  @Input() buttonContent: TemplateRef<any>;
  @Input() buttonText: string;
  @Input() buttonTheme: ButtonTheme;
  @Input() buttonType: ButtonType = 'button';
  @Input() roleType: string | null = null;
  @Input() redirectURL: string;
  @Input() queryParams: { [key: string]: string | number } | null = null;
  @Input() isDisabled: boolean;
  @Input() isTargetBlank: boolean;
  @Input() iconPath: string;
  @Input() ariaLabel: string;
  @Output() clickFn = new EventEmitter<MouseEvent>();

  ngOnInit(): void {
    const classNames = [this.buttonClass, this.buttonTheme].filter(
      (className) => className,
    ); // Remove null/undefined Inputs

    this.fullButtonClass = classNames.join(' ');
  }

  buttonMode(): ButtonMode {
    if (!this.redirectURLExists()) {
      return 'callback';
    }

    if (this.isInternalURL()) {
      return 'internalURL';
    } else {
      return 'externalURL';
    }
  }

  private redirectURLExists(): boolean {
    return !!this.redirectURL;
  }

  private isInternalURL(): boolean {
    return !(
      this.redirectURL.toString().startsWith('http://') ||
      this.redirectURL.toString().startsWith('https://')
    );
  }
}
